<template>

  <t-page>


    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #title-buttons>

        <t-button @click="confirmReverse()"
                  v-show="(command === 'view')"
                  :sending="reverseAverage"
                  enable-loader>
          <b-icon-file-earmark-text class="mr-1"></b-icon-file-earmark-text>
          Recalcular Médias
        </t-button>

      </template>


      <template #default>

        <t-input v-model="form[fieldKey]" hidden/>

        <b-row>

          <t-input fixed highlight cols="4" v-model="form.responseList.lotCodeLabel" label="Lote Relacionado"/>

          <t-input fixed cols="4" v-model="form.responseList.producedDate" date label="Período Lote Inicial"/>
          <t-input fixed cols="4" v-model="form.responseList.producedDateEnd" date label="Período Lote Final"/>

        </b-row>

        <b-row>


          <t-input fixed cols="4" v-model="form.responseList.groupProduct" label="Grupo"/>

          <t-input fixed cols="4" v-model="form.responseList.model" label="Modelo"/>

          <t-input fixed cols="4" v-model="form.dataFechamentoDados" date label="Data Fechamento"
                   help="Data considerada de limite para emissão de ordens de fabricação e consideração na composição da média dos valores gerados inicialmente. Regra padrão para lotes com período de intervalor superiores a 5 dias, será a data inicial + 4 dias. Para lotes com período inferior a 5 dias, serão considerados a média de todos as ordens geradas no sistema do mesmo lote"/>


        </b-row>

        <t-msg info>Dados utilizados para geração de novos certificados do mesmo lote e modelo de produtos, não sendo permitido alteração para evitar inconsistência em relação aos parâmetros gerais. Caso houver necessidade de modificação, altere os certificados emitidos individualmente.</t-msg>
        <t-form-card title="Parâmetros calculados" class="mt-2">

          <b-row>

            <t-input cols="6" v-model="form.adsorcaoIodo" accept-zero number decimals="2"
                     label="Absorção de Iodo (g/Kg)"/>
            <t-input cols="6" v-model="form.absorcaoOleo" accept-zero number decimals="2"
                     label="Absorção de Óleo (ml/100g)"/>

          </b-row>

          <b-row>

            <t-input cols="6" v-model="form.teorResiduos325mesh" accept-zero number decimals="4"
                     label="Teor de Resíduos  325 mesh (ppm)"/>
            <t-input cols="6" v-model="form.teorResiduos35mesh" accept-zero number decimals="4"
                     label="Teor de Resíduos  35 mesh (ppm)"/>

          </b-row>

          <b-row>

            <t-input cols="6" v-model="form.teorUmidade" accept-zero number decimals="2"
                     label="Teor de Umidade (%)"/>

            <t-input cols="6" v-model="form.teorCinzas" accept-zero number decimals="2"
                     label="Teor de Cinzas (%)"/>

          </b-row>

          <b-row>

            <t-input cols="6" v-model="form.teorFinos" accept-zero number decimals="2"
                     label="Teor de Finos (%)"/>

            <t-input cols="6" v-model="form.teorAtrito" accept-zero number decimals="2"
                     label="Teor de Atrito (%)"/>


          </b-row>

          <b-row>

            <t-input cols="6" v-model="form.ph" accept-zero number decimals="2"
                     label="pH"/>

            <t-input cols="6" v-model="form.durezaGraos" small="Informando somente com layout especifico" number
                     decimals="2"
                     label="Dureza Graos (%)"/>

          </b-row>

          <b-row>

            <t-input cols="6" v-model="form.densidadePeletizado" number
                     decimals="2"
                     label="Densidade Aparente (Kg/m³)"/>

            <t-input cols="6" v-model="form.durezaGraosMedia5Maiores" number
                     decimals="2"
                     label="Dureza de Grãos (Média 5> Maiores)" />

          </b-row>


          <b-row>

            <t-input cols="6" v-model="form.areaNSA" number
                     decimals="2" small="Informado com layout Pirelli"
                     label="Área Superficial NSA m²/g"/>

            <t-input cols="6" v-model="form.areaSTSA" number
                     decimals="2" small="Informado com layout Pirelli"
                     label="Área Superficial STSA m²/g"/>

          </b-row>

          <b-row>

            <t-input cols="6" v-model="form.transmitancia" accept-zero number decimals="2"
                     label="Transmitância (Descolaração por Tolueno) (%)"/>

          </b-row>



          <t-msg info>Abaixo, campos especificos para pó</t-msg>


          <b-row>

            <t-input cols="6" v-model="form.teorAco" accept-zero number decimals="4"
                     label="Teor de Aço (ppm)"/>

          </b-row>

          <b-row>

            <t-input cols="6" v-model="form.densidadePo" accept-zero number decimals="2"
                     label="Densidade pó kg/m³"/>
            <t-input cols="6" v-model="form.retido500" accept-zero number decimals="2"
                     label="Retido #500 (%) pó"/>

          </b-row>


        </t-form-card>

        <t-form-card title="Origem do cálculo">

          <t-msg info>São consideramos somente Ordens finalizadas, cujas mesmas características como forma física e embalagem estejam contempladas, além da etapa da qualidade estiver preenchida no momento da geração do laudo. Outro ponto importante é em relação a data de fechamento dos parâmetros que neste momento a regra de negócio permite somente até 4 dias de diferença em relação a data inicial do lote. Por tanto lotes com mais de 5 dias de período serão considerados somente as ordens produzidas dentro dos primeiros 5 dias.</t-msg>

          <t-table :fields="originFields" :items="form.origin"
                   link-primary-column="productionOrderCodeLabel"
                   disable-link-primary-column
                   disable-actions-column
                   primary-key-column="productionOrderBatchId">

            <template #first-column="{item}">
              <a :href="'/custom/production/order/'+item.productionOrderNumber" target="_blank">{{item.productionOrderCodeLabel}}</a>
            </template>

          </t-table>

        </t-form-card>

        <b-row>

          <t-input cols="6" v-model="form.logControl.createdUser" label="Usuário Criação" fixed/>
          <t-input cols="6" v-model="form.logControl.createdDate" label="Data Criação" fixed datetime/>

        </b-row>

        <b-row>

          <t-input cols="6" v-model="form.logControl.updatedUser" label="Usuário Modificação" fixed/>
          <t-input cols="6" v-model="form.logControl.updatedDate" label="Data Modificação" fixed datetime/>

        </b-row>


        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>


      </template>


    </t-page-form>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import ui from "@/assets/scripts/ui";
import http from "@/services/config/http-common";


export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'PolimixQualityReportForm',
  data() {
    return {
      path: "custom/polimix/quality-param-by-lot", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "qualityParamId",
      enableGeneralFields: false,
      form: {
        qualityParamId: 0,
        lotId: 0,
        issueDate: "",
        absorcaoOleo: "",
        durezaGraos: 0,
        teorCinzas: 0,
        teorResiduos325mesh: 0,
        teorResiduos35mesh: 0,
        teorUmidade: 0,
        adsorcaoIodo: 0,
        teorFinos: 0,
        teorAtrito:0,
        ph: 0,
        retido500: 0,
        transmitancia: 0,
        teorAco: 0,
        densidadePo: 0,
        areaNSA: 0,
        areaSTSA: 0,
        densidadePeletizado: 0,
        durezaGraosMedia5Maiores: 0,
        dataFechamentoDados: "",
        responseList: {},
        logControl: {
          updatedUser: "",
          updatedDate: "",
        },
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend

      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      reverseAverage: false,
      originFields: [
        {
          key: "productionOrderCodeLabel",
          label: "Ordem de Fabricação"
        },
        {
          key: "issueDate",
          label: "Data Produção",
          formatter: "date"
        },
      ]
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },

    async mountedContinued() {

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async confirmReverse() {

      ui.msgConfirm(this, 'RECALCULAR MÉDIAS', '<span class="text-danger">Tem certeza que deseja realizar o cálculo das médias dos parâmetros para este lote?', async () => {

        this.reverseAverage = true

        await http.get(this.userAuth.currentPage.path + "/reverse-average/" + this.form.qualityParamId).then(async () => {

          await this.goPath(this.userAuth.currentPage.path, {
            codSuccess: 100,
            returnMessage: 'Parâmetros do Lote recalculado sucesso!'
          })

        }).catch(error => ui.generalResponseError(this, error))

        this.reverseAverage = false

      })

    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>